<template>
  <div>
    <header-title :Title="'资源管理'"></header-title>
    <div>
      <el-card style="border-radius: 0.25rem">
        <el-row>
          <el-col class="flex-items">
            <div class="flex-items">
              <div style="font-size: 0.2rem" class="flex-shink">省市区：</div>
              <el-select
                v-model="codeListValue"
                placeholder="请选择"
                style="width: 1.875rem"
              >
                <el-option
                  v-for="item in codeList"
                  :key="item.Code"
                  :label="item.Name"
                  :value="item.Code"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items m-l">
              <div style="font-size: 0.2rem" class="flex-shink">状态筛选：</div>
              <el-select
                v-model="statusListValue"
                placeholder="请选择"
                style="width: 1.875rem"
                @change="ManageGetHx_SourceByPage"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items m-l">
              <div style="font-size: 0.2rem" class="flex-shink">场所类型：</div>
              <el-select
                v-model="sourceListValue"
                placeholder="请选择"
                style="width: 1.875rem"
              >
                <el-option
                  v-for="item in sourceList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items m-l">
              <div style="font-size: 0.2rem" class="flex-shink">资源类型：</div>
              <el-select v-model="resourceListValue" placeholder="请选择">
                <el-option
                  v-for="item in resourceList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items m-l">
              <div style="font-size: 0.2rem" class="flex-shink">场所名称：</div>
              <el-input
                style="width: 2.175rem"
                v-model="Name"
                placeholder="请输入"
              ></el-input>
            </div>
          </el-col>
          <el-col style="margin-top: 20px">
            <el-button
              type="primary"
              round
              style="background: #27abf7"
              icon="el-icon-plus"
              @click="onClickAddResource"
              >新 增</el-button
            >
            <el-button
              type="primary"
              style="background: #27abf7"
              round
              @click="ManageGetHx_SourceByPage"
              >查询</el-button
            >
            <el-button round @click="layoutData">清空</el-button>
          </el-col>
          <!-- 按钮 -->
          <!-- <el-col style="margin-top: 0.25rem">
            <el-button
              type="primary"
              round
              style="background: #27abf7"
              icon="el-icon-plus"
              @click="onClickAddResource"
              >新 增</el-button
            >
          </el-col> -->
        </el-row>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 0.375rem"
          :header-cell-style="{ background: '#FAFAFA', color: '#000' }"
        >
          <el-table-column label="序号" align="center" width="50">
            <template slot-scope="scope">
              {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="AreaName"
            label="辖区"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="SourceTypeName"
            label="场所类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="Name" label="场所名称" align="center">
          </el-table-column>
          <el-table-column prop="Address" label="场所地址" align="center">
          </el-table-column>
          <el-table-column label="开放时间" align="center">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.BusinessHours"
                placement="top-start"
              >
                <div class="tui-text">
                  {{ scope.row.BusinessHours }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="ClassName"
            label="幼儿班级"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="StudentName"
            label="幼儿姓名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="RelationShip"
            label="亲子关系"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="onClickEdit(scope.row)"
                >编辑</el-button
              >
              <el-button type="text" @click="onClickDetail(scope.row)"
                >删除</el-button
              >
              <el-button
                type="text"
                @click="onClickMakerDetail(scope.row)"
                v-if="statusListValue != '0'"
                >预约详情</el-button
              >
              <el-button
                type="text"
                v-if="statusListValue == '0'"
                @click="onClickCheck(scope.row)"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="PageIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="text-align: center; padding: 20px 0 0 0"
        >
        </el-pagination>
      </el-card>
    </div>
    <!-- 新增场馆信息 -->
    <el-dialog
      :title="Title"
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="tui-dialog"
    >
      <div>
        <div style="padding-bottom: 20px; color: #32c5ff">
          如选项未知请填写“无”
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          :label-position="`left`"
          label-width="130px"
        >
          <el-form-item label="资源归属：" prop="addResourceListValue">
            <el-select
              v-model="ruleForm.addResourceListValue"
              placeholder="请选择"
              :disabled="Title == '修改场馆信息'"
            >
              <el-option
                v-for="item in addResourceList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Name"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="选择班级："
            v-if="ruleForm.addResourceListValue == '家长资源'"
            prop="ClassId"
          >
            <el-select
              :disabled="Title == '修改场馆信息'"
              v-model="ruleForm.ClassId"
              placeholder="请选择班级"
              @change="classListOnChange"
            >
              <el-option
                v-for="item in classList"
                :key="item.ClassId"
                :label="item.GradeName + '' + item.ClassName"
                :value="item.ClassId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="亲子关系："
            v-if="ruleForm.addResourceListValue == '家长资源'"
            prop="RelationShip"
          >
            <el-select
              :disabled="Title == '修改场馆信息'"
              v-model="ruleForm.RelationShip"
              placeholder="请选择"
            >
              <el-option
                v-for="item in releationShipList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="ruleForm.addResourceListValue == '家长资源'">
            <el-form-item
              label="选择提供者："
              v-if="CustomerInfosList && CustomerInfosList.length != 0"
              prop="StudentId"
            >
              <el-select
                :disabled="Title == '修改场馆信息'"
                v-model="ruleForm.StudentId"
                placeholder="请选择提供者"
              >
                <el-option
                  v-for="item in CustomerInfosList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item
            label="权限设置："
            prop="SourceRole"
            v-if="ruleForm.addResourceListValue == '家长资源'"
          >
            <el-radio-group v-model="ruleForm.SourceRole">
              <el-radio :label="0">全园</el-radio>
              <el-radio :label="1">所属班级</el-radio>
              <el-radio :label="2">所属年级</el-radio>
            </el-radio-group>
            <!-- <el-select v-model="ruleForm.SourceRole" placeholder="请选择权限">
              <el-option
                v-for="item in roleList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="场馆类型：" prop="SourceTypeId">
            <el-select v-model="ruleForm.SourceTypeId" placeholder="请选择">
              <el-option
                v-for="item in sourceList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省市区：" prop="AreaCode">
            <el-select v-model="ruleForm.AreaCode" placeholder="请选择">
              <el-option
                v-for="item in codeList"
                :key="item.Code"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场馆名称：" prop="Name">
            <!-- <el-input v-model="ruleForm.Name"></el-input> -->
            <el-autocomplete
              style="width: 100%"
              v-model="ruleForm.Name"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              placeholder="请输入场馆名称"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item label="地址：" prop="Address">
            <el-input v-model="ruleForm.Address"></el-input>
          </el-form-item>
          <el-form-item label="情感教育关键词：">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <div style="margin: 15px 0"></div>
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="电话：">
            <el-input v-model="ruleForm.Tel" ></el-input>
          </el-form-item>
          <el-form-item label="营业时间：">
            <el-input v-model="ruleForm.BusinessHours"></el-input>
          </el-form-item>
          <el-form-item label="公交信息：">
            <el-input v-model="ruleForm.Transit"></el-input>
          </el-form-item>
          <el-form-item label="场馆介绍：">
            <el-input v-model="ruleForm.Detail" type="textarea"></el-input>
          </el-form-item>

          <el-form-item label="场馆封面：">
            <el-upload
              class="avatar-uploader"
              action="/api/img/UploadImg"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="coverBeforeAvatarUpload"
            >
              <img v-if="ruleForm.Img" :src="ruleForm.Img" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="场馆图片：">
            <div class="UpdateBox">
              <div
                class="imageBox"
                v-for="(item, index) in ruleForm.ImgList"
                :key="index"
              >
                <i
                  class="el-icon-delete deleteIcon"
                  @click="handleUploadRemove(index)"
                ></i>

                <img :src="item" alt="" />
              </div>
              <el-upload
                class="avatar-uploader"
                action="/api/Img/UploadImage/"
                :show-file-list="false"
                :on-success="handleUploadSuccess"
                :before-upload="beforeAvatarUpload"
                :headers="token"
                :multiple="true"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" round>取 消</el-button>
        <el-button type="primary" round @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 预约详情 -->
    <el-dialog
      title="教师场馆预约详情"
      :visible.sync="makerDialogVisible"
      width="60%"
      custom-class="tui-dialog"
    >
      <div>
        <div class="flex-items">
          <div class="flex-items tui-makerDetailDialog">
            <div>场馆名称：</div>
            <div style="font-weight: 600">{{ makeInfo.Name }}</div>
          </div>
          <div
            class="flex-items tui-makerDetailDialog"
            style="padding-left: 2.375rem"
          >
            <div>场馆地址：</div>
            <div style="font-weight: 600">{{ makeInfo.Address }}</div>
          </div>
        </div>
        <div style="padding-top: 30px">
          <el-table
            :data="makeTableData"
            style="width: 100%"
            :header-cell-style="{ color: '#000' }"
          >
            <el-table-column label="序号" width="50" align="center">
              <template slot-scope="scope">
                {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="TeamLeader" label="带队者" align="center">
            </el-table-column>
            <el-table-column prop="ClassName" label="班级" align="center">
            </el-table-column>
            <el-table-column label="参与学生" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" width="300" trigger="click">
                  <div class="flex" style="flex-wrap: wrap">
                    <div
                      v-for="(tag, index) in scope.row.Students"
                      :key="index"
                      style="margin: 5px"
                    >
                      {{ tag }}
                    </div>
                  </div>
                  <el-button
                    icon="el-icon-search"
                    slot="reference"
                    circle
                  ></el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="Status" label="状态" align="center">
            </el-table-column>
            <el-table-column
              prop="Time"
              label="时间"
              align="center"
              width="300"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChangeMake"
            @current-change="handleCurrentChangeMake"
            :current-page="PageIndexMake"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="PageSizeMake"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalMake"
            style="text-align: center;padding:20px; 0 0 0"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="makerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="makerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 审核详情 -->
    <el-dialog
      title="审核详细信息"
      :visible.sync="dialogVisibleDetail"
      width="50%"
    >
      <div>
        <el-descriptions title="详细信息">
          <el-descriptions-item label="场馆名称">{{
            ruleForm.Name
          }}</el-descriptions-item>
          <el-descriptions-item label="场馆地址">{{
            ruleForm.Address
          }}</el-descriptions-item>
          <el-descriptions-item label="电话">{{
            ruleForm.Tel
          }}</el-descriptions-item>
          <el-descriptions-item label="营业时间">
            {{ ruleForm.BusinessHours }}
          </el-descriptions-item>
          <el-descriptions-item label="公交信息">{{
            ruleForm.Transit
          }}</el-descriptions-item>
          <el-descriptions-item label="场馆介绍">{{
            ruleForm.Detail
          }}</el-descriptions-item>
          <el-descriptions-item label="场馆图片">
            <div
              class="flex"
              style="flex-wrap: wrap; justify-content: space-around"
            >
              <el-image
                v-for="(item, index) in ruleForm.ImgList"
                :key="index"
                style="width: 200px; height: 200px; margin-bottom: 20px"
                :src="item"
                fit="cover"
              ></el-image>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDetail = false">取 消</el-button>
        <el-button @click="isCheck(ruleForm, '驳回')" type="danger"
          >驳 回</el-button
        >
        <el-button type="primary" @click="isCheck(ruleForm, '通过')"
          >审核通过</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const cityOptions = [
  "自我激励能力",
  "情绪调控能力",
  "延迟满足能力",
  "移情能力",
  "情感交往能力",
  "道德感",
  "理智感",
  "美感",
];

import headerTitle from "@/components/headerTitle/headerTitle.vue";
import {
  GetSourceTypeList,
  GetRegionList,
  ManageGetHx_SourceByPage,
  GetClassByCustomerId,
  ManageAddHx_SourceInfo,
  ManageGetHx_SourceDetail,
  ManageDeleteHx_SourceInfo,
  GetMakeDetailBySource,
  CheckSourceInfo,
  SourceNameCheck,
} from "../../api/api";
import _ from "lodash";

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      Title: "",
      ruleForm: {
        AreaCode: "",
        AreaName: "",
        SourceTypeId: "",
        Name: "",
        Address: "",
        Detail: "",
        Img: "",
        ImgList: [],
        ClassId: "",
        BusinessHours: "",
        Transit: "",
        Tel: "",
        Tag: "",
        SourceId: 0,
        StudentId: "",
        goOn: 0,
        RelationShip: "",
        addResourceListValue: "",
        SourceRole: 0,
      },
      rules: {
        Name: [{ required: true, message: "请输入场馆名称", trigger: "blur" }],
        RelationShip: [
          { required: true, message: "请选择亲子关系", trigger: "change" },
        ],
        Address: [
          { required: true, message: "请输入场馆地址", trigger: "blur" },
        ],
        Detail: [
          { required: true, message: "请输入场馆介绍", trigger: "blur" },
        ],
        BusinessHours: [
          { required: true, message: "请输入营业时间", trigger: "blur" },
        ],
        Transit: [
          { required: true, message: "请输入公交信息", trigger: "blur" },
        ],
        Tel: [{ required: true, message: "请输入电话号码", trigger: "blur" }],
        Tag: [{ required: true, message: "请输入场馆标签", trigger: "change" }],
        ClassId: [{ required: true, message: "请选择班级", trigger: "change" }],
        SourceTypeId: [
          { required: true, message: "请选择场馆类型", trigger: "change" },
        ],
        AreaCode: [
          { required: true, message: "请选择省市区", trigger: "change" },
        ],
        addResourceListValue: [
          { required: true, message: "请选择资源归属", trigger: "change" },
        ],
        SourceRole: [
          { required: true, message: "请选择权限设置", trigger: "change" },
        ],
        StudentId: [
          { required: true, message: "请选择提供者", trigger: "change" },
        ],
      },
      imgFilesLists: [],
      token: {
        Authorization: "Bearer ",
      },
      loading: null,
      makerDialogVisible: false,
      sourceList: [],
      sourceListValue: "",
      codeList: [],
      codeListValue: "",
      userInfo: {},
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      Name: "",
      classList: [],
      classListId: "",
      options: [],
      makeInfo: {},
      PageIndexMake: 1,
      PageSizeMake: 10,
      totalMake: 0,
      makeTableData: [],
      CustomerInfosList: [],
      releationShipList: [
        {
          text: "幼儿母亲",
          value: "1",
        },
        {
          text: "幼儿父亲",
          value: "2",
        },
        {
          text: "幼儿爷爷",
          value: "3",
        },
        {
          text: "幼儿奶奶",
          value: "4",
        },
        {
          text: "幼儿外公",
          value: "5",
        },
        {
          text: "幼儿外婆",
          value: "6",
        },
        {
          text: "其他",
          value: "7",
        },
        {
          text: "无",
          value: "0",
        },
      ],
      statusList: [
        {
          label: "待审核",
          value: "0",
        },
        {
          label: "已发布",
          value: "1",
        },
      ],
      statusListValue: "1",
      resourceList: [
        {
          Name: "社会资源",
          Id: "1",
        },
        {
          Name: "家长资源",
          Id: "2",
        },
        {
          Name: "全部",
          Id: "0",
        },
      ],
      resourceListValue: "0",
      likeList: [
        {
          Name: "从大到小",
          Id: "1",
        },
        {
          Name: "默认排序",
          Id: "0",
        },
      ],
      likeListValue: "0",
      addResourceList: [
        {
          Name: "社会资源",
          Id: "1",
        },
        {
          Name: "家长资源",
          Id: "2",
        },
      ],
      roleList: [
        {
          Name: "全园",
          Id: 0,
        },
        {
          Name: "所属班级",
          Id: 1,
        },
        {
          Name: "所属年级",
          Id: 2,
        },
      ],
      dialogVisibleDetail: false,
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    this.GetSourceTypeList();
    this.GetRegionList();
    this.ManageGetHx_SourceByPage();
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleSelect(e) {
      console.log(e);
      this.$router.push({
        path: "/tool-Map/detail",
        query: {
          t: +new Date(), //保证每次点击路由的query项都是不一样的，确保会重新刷新view
          SourceId: e.Id,
          ClassId: 0,
        },
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString != "") {
        let callBackArr = [];
        let res = await SourceNameCheck({
          Name: queryString,
        });
        if (res.data.success) {
          this.isActive = true;
          res.data.response.forEach((item) => {
            if (item.Name.indexOf(queryString) > -1) {
              callBackArr.push({
                Id: item.Id,
                value: item.Name,
              });
            }
          });
          //console.log(callBackArr);
          if (callBackArr.length == 0) {
            this.isActive = false;
          } else {
            cb(callBackArr);
          }
        }
      }
    },
    getData(val) {
      var content = val.Students.join(",");
      return content;
    },
    getJson(val) {
      console.log(val);
      if (val) {
        return val.join(",");
      }
    },
    // 选择班级
    classListOnChange(e) {
      this.ruleForm.ClassId = e;
      let result = this.classList.find((item) => item.ClassId == e);

      if (result) {
        this.CustomerInfosList = result.CustomerInfosList.map((cc) => {
          return {
            value: cc.CustomerId,
            text: cc.CustomerName,
          };
        });
      }
      this.ruleForm.StudentId = "";
      //console.log(this.CustomerInfosList);
    },
    coverBeforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.Img = res.response;
    },
    // 删除场馆
    async onClickDetail(val) {
      this.$confirm("此操作将永久删除该场馆, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await ManageDeleteHx_SourceInfo({
            Ids: [val.SourceId],
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.PageIndex = 0;
            this.ManageGetHx_SourceByPage();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async onClickEdit(val) {
      this.Title = "修改场馆信息";
      this.GetClassByCustomerId();

      let res = await ManageGetHx_SourceDetail({
        Id: val.SourceId,
      });

      if (res.data.success) {
        this.ruleForm = JSON.parse(JSON.stringify(res.data.response));
        console.log(this.ruleForm);
        this.cities = cityOptions;
        if (res.data.response.Tag) {
          var Arr = res.data.response.Tag.split("|");
          this.checkedCities = res.data.response.Tag.split("|");
          this.cities = this.cities.concat(Arr);

          this.cities = [...new Set(this.cities)];
          console.log(this.cities, "list");
        } else {
          this.checkedCities = [];
        }
        this.ruleForm.RelationShip = res.data.response.RelationShip + "";

        this.ruleForm.addResourceListValue =
          res.data.response.ClassId == 0 ? "社会资源" : "家长资源";
        this.ruleForm.ClassId =
          res.data.response.ClassId == 0 ? "" : res.data.response.ClassId;

        this.dialogVisible = true;
      }
    },
    onChangeTag(e) {
      this.ruleForm.Tag = e;
    },
    // 重置新增数据
    resetData() {
      this.ruleForm = {
        AreaCode: "",
        AreaName: "",
        SourceTypeId: "",
        Name: "",
        Address: "",
        Detail: "",
        Img: "",
        ImgList: [],
        ClassId: "",
        BusinessHours: "",
        Transit: "",
        Tel: "",
        Tag: "",
        SourceId: 0,
        StudentId: "",
        goOn: 0,
        RelationShip: "",
        addResourceListValue: "",
        SourceRole: 0,
      };
      this.imgFilesLists = [];
      this.checkedCities = [];
    },
    // 新增场馆信息
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let result = this.codeList.find(
            (item) => item.Code == this.ruleForm.AreaCode
          );
          let params = {
            AreaCode: this.ruleForm.AreaCode,
            AreaName: result.Name,
            SourceTypeId: this.ruleForm.SourceTypeId,
            Name: this.ruleForm.Name,
            Address: this.ruleForm.Address,
            Detail: this.ruleForm.Detail,
            Img: this.ruleForm.Img,
            ImgList: this.ruleForm.ImgList,
            ClassId: this.ruleForm.ClassId == "" ? 0 : this.ruleForm.ClassId,
            BusinessHours: this.ruleForm.BusinessHours,
            Transit: this.ruleForm.Transit,
            Tel: this.ruleForm.Tel,
            Tag: this.checkedCities.join("|"),
            SourceId: this.ruleForm.SourceId,
            StudentId:
              this.ruleForm.StudentId == "" ? 0 : this.ruleForm.StudentId,
            goOn: this.ruleForm.goOn,
            RelationShip:
              this.ruleForm.RelationShip == "无" ||
              this.ruleForm.RelationShip == ""
                ? 0
                : this.ruleForm.RelationShip,
            SourceRole:
              this.ruleForm.SourceRole == "" ? 0 : this.ruleForm.SourceRole,
          };
          //console.log(params);
          let res = await ManageAddHx_SourceInfo(params);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.ManageGetHx_SourceByPage();
            this.resetData();
            this.$refs[formName].resetFields();
            this.dialogVisible = false;
          } else {
            if (res.data.msg == "有相似场馆是否继续添加") {
              this.$confirm("有相似场馆是否继续添加?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(async () => {
                this.ruleForm.goOn = 1;
                this.submitForm(formName);
              });
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    async ManageGetHx_SourceByPage() {
      let res = await ManageGetHx_SourceByPage({
        AreaCode: this.codeListValue,
        SourceTypeId: this.sourceListValue == "" ? 0 : this.sourceListValue,
        SchoolId: this.userInfo.SchoolId,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.Name,
        Status: this.statusListValue,
        IsSociety: this.resourceListValue,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    layoutData() {
      this.codeListValue = "";
      this.sourceListValue = "";
      this.PageIndex = 1;
      this.Name = "";
      this.likeListValue = "0";
      this.resourceListValue = "0";
      this.ManageGetHx_SourceByPage();
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.ManageGetHx_SourceByPage();
    },
    //分页
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.ManageGetHx_SourceByPage();
    },
    handleSizeChangeMake(e) {
      this.PageSizeMake = e;
      this.GetMakeDetailBySource();
    },
    //分页
    handleCurrentChangeMake(val) {
      this.PageIndexMake = val;
      this.GetMakeDetailBySource();
    },
    // 场所类型
    async GetSourceTypeList() {
      let res = await GetSourceTypeList();
      if (res.data.success) {
        this.sourceList = res.data.response;
      }
    },
    // 省市区
    async GetRegionList() {
      let res = await GetRegionList({ Code: 310100 });
      if (res.data.success) {
        this.codeList = res.data.response;
      }
    },
    // 获取班级
    async GetClassByCustomerId() {
      let res = await GetClassByCustomerId({
        Id: 0,
        IsTeacher: this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
      });
      if (res.data.success) {
        this.classList = res.data.response;
      }
    },
    async isCheck(item, type) {
      if (type == "通过") {
        let res = await CheckSourceInfo({
          sourceId: item.SourceId,
          status: 1,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "审核通过!",
          });
          this.resetData();
          this.ManageGetHx_SourceByPage();
          this.dialogVisibleDetail = false;
        } else {
          this.$message({
            type: "error",
            message: "审核失败!",
          });
        }
      } else {
        let res = await CheckSourceInfo({
          sourceId: item.SourceId,
          status: 2,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "驳回申请!",
          });
          this.resetData();
          this.ManageGetHx_SourceByPage();
          this.dialogVisibleDetail = false;
        } else {
          this.$message({
            type: "error",
            message: "驳回失败!",
          });
        }
      }
    },
    // 审核
    async onClickCheck(item) {
      this.GetClassByCustomerId();
      let res = await ManageGetHx_SourceDetail({
        Id: item.SourceId,
      });

      if (res.data.success) {
        this.ruleForm = JSON.parse(JSON.stringify(res.data.response));

        this.ruleForm.ClassId =
          res.data.response.ClassId == 0 ? "" : res.data.response.ClassId;
        this.dialogVisibleDetail = true;
      }
    },
    async onClickMakerDetail(item) {
      this.makeInfo = item;
      this.GetMakeDetailBySource();
      this.makerDialogVisible = true;
    },
    // 预约详情
    async GetMakeDetailBySource() {
      let res = await GetMakeDetailBySource({
        Id: this.makeInfo.SourceId,
        PageIndex: this.PageIndexMake,
        PageSize: this.PageSizeMake,
      });
      if (res.data.success) {
        this.makeTableData = res.data.response.data;
        this.totalMake = res.data.response.dataCount;
      } else {
        this.makeTableData = [];
      }
    },
    onClickAddResource() {
      this.resetData();
      this.Title = "新增场馆信息";
      this.GetClassByCustomerId();
      this.dialogVisible = true;
    },
    // 文件上传变化
    handleFileChange(file, fileList) {
      // this.imgFilesLists.push(file.response.response);
      this.ruleForm.ImgList.push(file.response.response);
      //console.log(file, "fileList");
    },
    handleUploadSuccess(response, file, fileList) {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
      this.handleFileChange(file, fileList);
    },
    beforeAvatarUpload(file) {
      let type = file.type.split("/");
      //console.log(type);
      if (file.size > 1024 * 1024 * 2) {
        this.$message.warning("请保持在2M以内");
        return false;
      }
      if (type[0] == "image") {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (isLt2M) {
          if (!this.loading) {
            this.loading = this.$loading({
              lock: true,
              text: "上传中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
          }
          return true;
        } else {
          this.$message.error("上传头像图片大小不能超过 2MB!");
          return false;
        }
      } else {
        this.$message.warning("请上传视频");
        return false;
      }
    },
    handleUploadRemove(index) {
      this.ruleForm.ImgList.splice(index, 1);
      // this.imgFilesLists.splice(index, 1);
    },
  },
};
</script>
<style lang="less">
.m-l {
  margin-left: 0.25rem;
}
.flex-shink {
  display: flex;
  flex-shrink: 0;
}
.tui-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.tui-makerDetailDialog {
  font-size: 0.2rem;
  color: #000;
}
.el-dialog__header {
  background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808145755_3530.png")
    no-repeat;
  padding: 30px 20px 30px;
  background-size: 100% 100%;
}
.tui-dialog {
  border-radius: 0.25rem;
  overflow: hidden;
}
.UpdateBox {
  padding-top: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .el-icon-plus {
    display: block;
    width: 148px;
    height: 148px;
    font-size: 20px;
    border: 1px #ccc dashed;
    line-height: 148px;
    text-align: center;
  }
  .imageBox {
    position: relative;
    .deleteIcon {
      width: 20px;
      height: 20px;
      top: 0;
      right: 10px;
      object-fit: contain;
      position: absolute;
      border: none;
      cursor: pointer;
      font-size: 20px;
    }
    img {
      object-fit: contain;
      // border: 1px #ccc dashed;
      display: block;
      width: 148px;
      height: 148px;
      margin-right: 10px;
    }
  }
}
</style>